import { Outlet, NavLink } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export default function Layout() {
  const { user, logout, isAdmin } = useAuth();

  return (
    <div className="min-h-screen bg-gray-50">
      <nav className="shadow-sm" style={{ backgroundColor: '#4568ff' }}>
        <div className="max-w-4xl mx-auto px-4">
          <div className="flex justify-between h-14">
            <div className="flex items-center">
              <NavLink to="/" className="flex items-center gap-3">
                <img
                  src="https://www.reflectiz.com/wp-content/themes/reflectiz/assets/images/sections/footer/logo.svg"
                  alt="Reflectiz"
                  className="h-6"
                />
              </NavLink>
              {isAdmin && (
                <>
                  <NavLink
                    to="/admin"
                    className={({ isActive }) =>
                      `ml-8 text-sm font-medium ${
                        isActive
                          ? 'text-blue-900'
                          : 'text-gray-50 hover:text-gray-100'
                      }`
                    }
                  >
                    Dashboard
                  </NavLink>
                  <NavLink
                    to="/admin/questions"
                    className={({ isActive }) =>
                      `ml-4 text-sm font-medium ${
                        isActive
                          ? 'text-blue-900'
                          : 'text-gray-50 hover:text-gray-100'
                      }`
                    }
                  >
                    Manage
                  </NavLink>
                </>
              )}
            </div>
<div className="flex items-center gap-6">
                  <span className="text-lg font-semibold text-white text-900">Ask Me Anything</span>
</div>
            <div className="flex items-center gap-4">
              <div className="text-sm text-gray-100">
                {user?.displayName}
                {isAdmin && (
                  <span className="ml-2 px-2 py-0.5 bg-blue-100 text-blue-800 text-xs font-medium rounded-full">
                    Admin
                  </span>
                )}
              </div>
              <button
                onClick={logout}
                className="text-sm text-gray-50 hover:text-gray-100"
              >
                Sign out
              </button>
            </div>
          </div>
        </div>
      </nav>

      <Outlet />
    </div>
  );
}
